import React from 'react';

const evaluateQuotesDocs = (
    <>
        <p>
            By Default, Trade Unafraid utilizes quotes in evaluating triggers. This is in order to try and give the user
            a
            small advantage by getting in early even if no trade has occurred at the trigger price. The idea is that if
            the quote breaks the price, it is very likely that an ensuing trade will as well. Uncheck this field to
            disable this front-run feature.

            <p>
                Example: Let's say you have a break price of 100 to go long. If no trade above 100 occurs, but Trade
                Unafraid receives a quote of bid :99.95- ask: 100.01, the entry will trigger long on the break of 100 by
                the ask. Similarly, let's say you have a candle trail with a low of 99. If no trade below 99 occurs, but
                Trade Unafraid receives a quote of bid: 98.99-ask:99.01, the exit will trigger on the bid below the low
                of 99.
            </p>
        </p>
    </>
);

export default evaluateQuotesDocs;